import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { UomService } from "../../lh-core/services/uom.service";
import { Subject, takeUntil } from "rxjs";
import { Uom } from "../../lh-core/model/uom";

@Component({
    selector: 'lh-uom-toggle',
    standalone: false,
    templateUrl: './uom-toggle.component.html',
    styleUrls: ['./uom-toggle.component.scss']
})
export class UomToggleComponent implements OnInit, OnDestroy, OnChanges {
    constructor(private uomService: UomService) { }
    
    private destroyed$ = new Subject();

    @Input() defaultUom: Uom = 'L'

    uom: Uom = this.defaultUom;

    ngOnInit(): void {
        this.uomService.current$.pipe(takeUntil(this.destroyed$)).subscribe(uom => {
            this.uom = uom;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['defaultUom'] && !changes['defaultUom'].firstChange) {
            this.uomService.changeUom(this.defaultUom);
        }
    }

    public onUomChange(value: any) {
        this.uomService.changeUom(value)
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
    }

}